import React from "react";
import PropTypes from "prop-types";
import Box from "@material-ui/core/Box";
import Typography from "@material-ui/core/Typography";
import InboxIcon from "@material-ui/icons/Inbox";

const EmptyState = ({
  message = "No hay registros para mostrar",
  icon: IconComponent = InboxIcon
}) => (
  <Box
    display="flex"
    flexDirection="column"
    alignItems="center"
    justifyContent="center"
    py={4}
  >
    <IconComponent style={{ fontSize: 48, color: "#bdbdbd" }} />
    <Typography
      variant="body1"
      color="textSecondary"
      style={{ marginTop: 8 }}
    >
      {message}
    </Typography>
  </Box>
);

EmptyState.propTypes = {
  message: PropTypes.string,
  icon: PropTypes.elementType
};

export default EmptyState;
